/*
 * Copyright (c) 2022 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { useRef, useState } from 'react';
import { Asset, Channel } from '@wit/vtv-x-foundation-lib';
import { ImageLoader } from '..';

interface Props {
  asset: Asset | Channel;
  onAssetClick?: (asset: Asset) => void;
  ctxId: number | string;
}

export default function ChannelCard({ asset, onAssetClick, ctxId }: Props): JSX.Element {
  const cardId = `${ctxId}-${asset.id}`;
  const customTimeout = useRef<ReturnType<typeof setTimeout>>();
  const [customClassName, setCustomClassName] = useState('');

  const handleMouseEnter = () => {
    customTimeout.current = setTimeout(() => {
      setCustomClassName('card-full-width');
    }, 1000);
  };

  const handleMouseLeave = () => {
    if (customTimeout && customTimeout.current) {
      clearTimeout(customTimeout.current);
    }
    setCustomClassName('');
  };

  return (
    <a
      className={`context-switch content-card small channel not-scheduled dynamic-content-card-container ${customClassName}`}
      key={asset.id}
      onClick={() => onAssetClick && onAssetClick(asset)}
      id={`Card___${cardId}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="border-radius-container">
        <div className="content-card-image">
          <ImageLoader
            bemModifier={cardId}
            src={asset.logo?.color?.uri || ''}
            className="content-card-channel channel-filling-card"
            fallbackText={asset.title}
            fallbackClass="channel-card-info"
            successClass="content-card-channel-logo"
            showFallbackOnLoading
          />
        </div>
      </div>
    </a>
  );
}
